module.exports = __webpack_public_path__ + "img/cameras.8fda274e.svg";